export default {
    state: {
        message: null,
        code: null,
        okayText: 'okay',
        okayFunction: null,
        cancelText: 'cancel',
        cancelFunction: null,
        confirmBox: false
    },
    mutations: {
        messageBox(state, {message, code, okayText, okayFunction, cancelText, cancelFunction, confirmBox}) {
            state.message = message;
            state.code = code || null;
            state.okayText = okayText || 'okay',
            state.okayFunction = okayFunction || null,
            state.cancelText = cancelText || 'cancel',
            state.cancelFunction = cancelFunction || null,
            state.confirmBox = confirmBox || false
        },
        resetMessageBoxMessage(state){
            state.message = null;
        }
    },
    actions: {
        openMessageBox({commit}, msgBox) {
            commit('messageBox', msgBox);
        },
        closeMessageBox({commit}) {
            commit('resetMessageBoxMessage');
        }
    }
};